import { useFormContext, useWatch } from 'form';
import { useTranslation } from 'i18n';
import { Box, Button, Stack, TypographyIcon } from 'ui';
import { FolderOutlined } from 'ui/icons';

import { AddGenericDocumentButton } from '../../../document';
import { BuyerMaterialSpecificationFormType } from '../../pages/schema';

export const DocumentSection = () => {
  const { t } = useTranslation('orders');
  const form = useFormContext<BuyerMaterialSpecificationFormType>();
  const [document, file_url] = useWatch({
    control: form.control,
    name: ['document', 'file_url'],
  });
  const onFileSelected = (file: File) => {
    form.setValue('file_url', undefined);
    form.setValue('document', { file });
  };

  const documentExists = !!(document || file_url);

  return (
    <Stack
      direction="row"
      sx={{
        gap: 2,
      }}
    >
      <Box>
        <AddGenericDocumentButton
          onFileSelected={onFileSelected}
          text={
            documentExists
              ? t('buyerMaterialSpecifications.documentSection.actions.replaceDocument')
              : t('buyerMaterialSpecifications.documentSection.actions.addDocument')
          }
        />
      </Box>
      <Box>
        {file_url ? (
          <Button component="a" target="_blank" href={file_url} variant="secondary">
            <TypographyIcon icon={FolderOutlined}>
              {t('buyerMaterialSpecifications.documentSection.actions.viewDocument')}
            </TypographyIcon>
          </Button>
        ) : null}
        {document ? (
          <Button variant="secondary">
            <TypographyIcon icon={FolderOutlined}>{document.file.name}</TypographyIcon>
          </Button>
        ) : null}
      </Box>
    </Stack>
  );
};
